module.exports = __webpack_public_path__ + "static/img/38814v.6e4e5ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/38814v.jpg
// module id = bjLR
// module chunks = 1